import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import Layout from "../../../../Layout/Layout";
// import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { InputField } from "../../../../Components/formElements/InputField";
// eslint-disable-next-line
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import DataTable from "react-data-table-component";

import ItemService from "../../../../services/customer_appCommonService";
import ItemService1 from "../../../../services/supplier_appCommonService";
import { getTodayDate } from "../../../../common/Validations";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";

const CreateWO = () => {
  const quotationID = useSelector(
    (state) => state?.customerV1?.costingSheet?.quotationID,
  );
  const navigate = useNavigate();

  // console.log(">>quotationDocData",quotationID)
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getPODetails, setPODetails] = useState([]);

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [isCardVisible, setCardVisible] = useState(true);

  const [getDropdownData, setDropdownData] = useState("");
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  const [getpurchaseGroup, setpurchaseGroup] = useState(0);
  // eslint-disable-next-line
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getCurrencyDropdown, setCurrencyDropdown] = useState([]);
  const [getVendorDropdownData, setVendorDropdownData] = useState([]);
  const [getVendorDropdown, setVendorDropdown] = useState([]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  let productDetailsCol = [
    {
      name: (
        <>
          <i className="bi bi-list-ol labelIcon"></i>
          Sl.No
        </>
      ),
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "100px",
    },
    {
      name: (
        <>
          <i className="bi bi-box-seam labelIcon"></i>
          Material
        </>
      ),
      selector: (row) => row.materialCode,
      sortable: true,
      width: "120px",
    },
    {
      name: (
        <>
          <i className="bi bi-card-text labelIcon"></i>
          Material Desc
        </>
      ),
      selector: (row) => row.materialDescription,
      sortable: true,
      width: "150px",
    },
    {
      name: (
        <>
          <i className="bi bi-tags labelIcon"></i>
          Material Grp
        </>
      ),
      selector: (row) => row.materialGroup,
      sortable: true,
      width: "120px",
    },
    {
      name: (
        <>
          <i className="bi bi-123 labelIcon"></i>
          QTY
        </>
      ),
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          disabled={true}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: (
        <>
          <i className="bi bi-rulers labelIcon"></i>
          UOM
        </>
      ),
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          disabled={true}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: (
        <>
          <i className="bi bi-currency-rupee labelIcon"></i>
          Rate
        </>
      ),
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          disabled={true}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: (
        <>
          <i className="bi bi-boxes labelIcon"></i>
          Bal QTY
        </>
      ),
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="balancePurchaseQuantity"
          placeholder=""
          value={row.balancePurchaseQuantity || ""}
          disabled={true}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: (
        <>
          <i className="bi bi-cart-check labelIcon"></i>
          Order QTY(MT)
        </>
      ),
      selector: (row) => row.dispatchDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderQuantityMT"
          placeholder=""
          value={row.orderQuantityMT || ""}
          disabled={true}
        />
      ),
      width: "150px",
    },
  ];

  const onInputChange = ({ target: { name, value } }) => {
    setPODetails((getPODetails) => ({ ...getPODetails, [name]: value }));
    // console.log("onInputChange => getPODetails", getPODetails);
  };
  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.code === "SA") {
      // Schedule Agreement
      setPODetails((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // setPOLineItemsCol(SchedulePOLineItemInitialCol);
      // setPOLineItemsData(SchedulePOLineItemInitialData);
    } else if (getDropdownData?.code === "SER") {
      // Service
      setPODetails((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // setPOLineItemsCol(ServicePOLineItemInitialCol);
      // setPOLineItemsData(ServicePOLineItemInitialData);
    } else if (getDropdownData?.code === "MAT") {
      // Material
      setPODetails((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // setPOLineItemsCol(POLineItemInitialCol);
      // setPOLineItemsData(POLineItemInitialData);
    } else {
      setPODetails((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  let productDetailsData = getPODetails?.items;

  useEffect(() => {
    poDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const poDetails = async () => {
    let obj = {
      documentNumber: quotationID,
    };
    await ItemService.getPODetail(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        console.log(">>PO data", item?.data);
        // setPODetails(item[0]?.data);
        setPODetails(item?.data?.[0] || {});
      } else {
        setPODetails([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const handleSave = async () => {
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: getPODetails,
    };
    await ItemService.addWorkOrder(obj).then((item) => {
      toast.dismiss(toastId);

      if (item?.status === 200) {
        toast.success(item?.message || "Work Order Created Successfully", {
          duration: 4000,
          position: "top-right",
        });
        navigate(CustomerConstants.WORK_ORDER_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    // setDisabled(false);
  };
  useEffect(() => {
    getMasterDataFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMasterDataFunc = async () => {
    // 1
    let obj1 = {};
    await ItemService1.getSupplierDatail(obj1).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setVendorDropdownData(item?.data);
      } else {
        setVendorDropdownData([]);
        console.log(">> Error: Loading getSupplierDatail");
      }
    });

    // 2
    let obj2 = {
      codeType: "purchaseOrganisation",
    };
    await ItemService1.getMasterData(obj2).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setPurchaseOrg(item?.data);
      } else {
        setPurchaseOrg([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj3 = {
      codeType: "companyCode",
    };
    await ItemService1.getMasterData(obj3).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj4 = {
      codeType: "INCOTerms",
    };
    await ItemService1.getMasterData(obj4).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setINCOTerms(item?.data);
      } else {
        setINCOTerms([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj6 = {
      codeType: "paymentTerm",
    };
    await ItemService1.getMasterData(obj6).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj14 = {
      codeType: "paymentTerm",
    };
    await ItemService1.getMasterData(obj14).then((item) => {
      if (item?.status === 200) {
        setpurchaseGroup(item?.data);
      } else {
        setpurchaseGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    // setLoader(false);
  };

  //file veiw
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle"> Create Work Order</h2>
                <p className="subText"> Create Work Order </p>
              </Col>
            </Row>
            <hr />
            {/*Document Header Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HD</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Header Details</span>
                      <span className="subHeaderTitle">
                        Document Description and Details{" "}
                      </span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                                  <POCollabrationCommonFillter />
                                </Col> */}
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="workOrderDocumentDate"
                          className="inputBox"
                          // label="Document Date"
                          label={
                            <>
                              <i className="bi bi-calendar-event labelIcon"></i>
                              Document Date
                            </>
                          }
                          name="workOrderDocumentDate"
                          placeholder=""
                          type="date"
                          value={getPODetails?.workOrderDocumentDate}
                          onChange={onInputChange}
                          // disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* Diff logic for this Only */}
                        <ComboboxField
                          className="dropdownOption"
                          // label="Vendor"
                          label={
                            <>
                              <i className="bi bi-person-vcard labelIcon"></i>
                              Vendor
                            </>
                          }
                          placeholder=""
                          data={getVendorDropdownData}
                          id="vendorName"
                          iconClassName="dropdownIcon"
                          name="vendorName"
                          setValue={getVendorDropdown?.name || []}
                          getvalue={setVendorDropdown}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="Purchase Organization"
                          label={
                            <>
                              <i className="bi bi-building labelIcon"></i>
                              Sales Organization
                            </>
                          }
                          extraLabel="SAP Sales organization"
                          placeholder=""
                          data={getPurchaseOrg}
                          id="salesOrderOrg"
                          iconClassName="dropdownIcon"
                          name="salesOrderOrg"
                          code="salesOrderOrgCode"
                          description="salesOrderOrgDesc"
                          setValue={getPODetails?.salesOrderOrg || []}
                          getvalue={setDropdownData}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="Purchase Group"
                          label={
                            <>
                              <i className="bi bi-people labelIcon"></i>
                              Sales Group
                            </>
                          }
                          name="salesOrderGroup"
                          data={getpurchaseGroup}
                          id="salesOrderGroup"
                          code="salesOrderGroupCode"
                          description="salesOrderGroupDesc"
                          iconClassName="dropdownIcon"
                          setValue={getPODetails?.salesOrderGroup || []}
                          getvalue={setDropdownData}
                          placeholder=""
                          // disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="Payment Terms"
                          label={
                            <>
                              <i className="bi bi-credit-card labelIcon"></i>
                              Payment Terms
                            </>
                          }
                          extraLabel=""
                          placeholder=""
                          data={getpaymentTerm}
                          id="paymentTerms"
                          iconClassName="dropdownIcon"
                          name="paymentTerms"
                          code="paymentTermsCode"
                          description="paymentTermsDesc"
                          setValue={getPODetails?.paymentTerms || []}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="INCOTerms"
                          label={
                            <>
                              <i className="bi bi-globe labelIcon"></i>
                              INCOTerms
                            </>
                          }
                          extraLabel="INCOTerms Code"
                          placeholder=""
                          data={getINCOTerms}
                          id="incoTerms"
                          iconClassName="dropdownIcon"
                          name="incoTerms"
                          code="incoTermsCode"
                          description="incoTermsDesc"
                          setValue={getPODetails?.incoTerms || []}
                          getvalue={setDropdownData}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="incoTermsLocation"
                          className="inputBox"
                          // label="INCOTerms Location"
                          label={
                            <>
                              <i className="bi bi-geo-alt labelIcon"></i>
                              INCOTerms Location
                            </>
                          }
                          name="incoTermsLocation"
                          placeholder=""
                          value={getPODetails?.incoTermsLocation}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="Currency"
                          label={
                            <>
                              <i className="bi bi-currency-rupee labelIcon"></i>
                              Currency
                            </>
                          }
                          placeholder=""
                          // data={getcurrency}
                          id="currency"
                          iconClassName="dropdownIcon"
                          name="currency"
                          code="currencyCode"
                          description="currencyDesc"
                          setValue={
                            getCurrencyDropdown?.name || {
                              code: "INR",
                              name: "INR-Rupee",
                            }
                          }
                          getvalue={setCurrencyDropdown}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          id="workOrderRemark"
                          className="inputBox"
                          // label="Purchasing Info"
                          label={
                            <>
                              <i className="bi bi-info-circle labelIcon"></i>
                              Work Order Info
                            </>
                          }
                          name="workOrderRemark"
                          placeholder=""
                          value={getPODetails?.workOrderRemark || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      {getPODetails?.purchaseType === "MAT - Material" && (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Process"
                              id="process"
                              // data={processOptions}
                              placeholder=""
                              value={getPODetails.process || ""}
                              name="process"
                              code="processCode"
                              description="processDesc"
                              setValue={getPODetails?.process || []}
                              getvalue={setDropdownData}
                              // disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="match"
                              label="Match"
                              placeholder=""
                              // data={getMatchType}
                              iconClassName="dropdownIcon"
                              name="match"
                              code="matchCode"
                              description="matchDesc"
                              setValue={getPODetails?.match || []}
                              getvalue={setDropdownData}
                              disabled={false}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">PO Details</span>
                      <span className="subHeaderTitle">PO Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4 d-flex align-items-center">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Purchase Order"
                          label={
                            <>
                              <i className="bi bi-file-earmark-text labelIcon"></i>
                              Purchase Order
                            </>
                          }
                          id="custPurchasingDocumentNr"
                          name="custPurchasingDocumentNr"
                          type="text"
                          value={
                            getPODetails?.custPurchasingDocumentNr || "" || ""
                          }
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="PO Date"
                          label={
                            <>
                              <i className="bi bi-calendar-date labelIcon"></i>
                              PO Date
                            </>
                          }
                          id="purchasingDocumentDate"
                          name="purchasingDocumentDate"
                          type="date"
                          value={
                            getPODetails?.purchasingDocumentDate ||
                            getTodayDate("") ||
                            ""
                          }
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="PO Value"
                          label={
                            <>
                              <i className="bi bi-currency-rupee labelIcon"></i>
                              PO Value
                            </>
                          }
                          id="purchasingDocumentValue"
                          name="purchasingDocumentValue"
                          type="number"
                          value={getPODetails?.purchasingDocumentValue}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          // label="PO Type"
                          label={
                            <>
                              <i className="bi bi-tags labelIcon"></i>
                              PO Type
                            </>
                          }
                          placeholder=""
                          // data={poTypeDropDown}
                          id="poType"
                          iconClassName="dropdownIcon"
                          name="poType"
                          code="customerCode"
                          description="poTypeDesc"
                          setValue={getPODetails?.poType || ""}
                          // getvalue={setDropdownData}
                          required={true}
                          disabled={true}
                          // error={validation.country}
                        />
                      </Col>
                      {getPODetails?.poType === "Open" && (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Valid From"
                              label={
                                <>
                                  <i className="bi bi-calendar-check labelIcon"></i>
                                  Valid From
                                </>
                              }
                              id="poValidFrom"
                              name="poValidFrom"
                              type="date"
                              value={getPODetails?.poValidFrom}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Valid To"
                              label={
                                <>
                                  <i className="bi bi-calendar-x labelIcon"></i>
                                  Valid To
                                </>
                              }
                              id="poValidTo"
                              name="poValidTo"
                              type="date"
                              value={getPODetails?.poValidTo}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                        </>
                      )}{" "}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Ship to Party"
                          label={
                            <>
                              <i className="bi bi-truck labelIcon"></i>
                              Ship to Party
                            </>
                          }
                          name="shipToParty"
                          placeholder=""
                          value={getPODetails?.customerCode || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex-column"
                      >
                        <InputField
                          className="inputBox"
                          // label="Customer Name"
                          label={
                            <>
                              <i className="bi bi-person labelIcon"></i>
                              Customer Name
                            </>
                          }
                          name="organisationName"
                          value={getPODetails?.organisationName || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Company Code"
                          label={
                            <>
                              <i className="bi bi-building labelIcon"></i>
                              Company Code
                            </>
                          }
                          name="companyCode"
                          placeholder=""
                          value={getPODetails?.companyCode || ""}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Customer Name"
                          placeholder=""
                          id="customerName"
                          iconClassName="dropdownIcon"
                          name="customerName"
                          code="customerCode"
                          description="customerNameDesc"
                          setValue={getPODetails?.customerName || ""}
                          // getvalue={setDropdownData}
                          required={true}
                          disabled={true}
                          // error={validation.country}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Project Name" //not get key
                          placeholder=""
                          // data={getProjects}
                          id="projectName"
                          iconClassName="dropdownIcon"
                          name="projectName"
                          code="projectNameCode"
                          description="projectNameDesc"
                          setValue={getPODetails?.projectName || ""}
                          // getvalue={setDropdownData}
                          required={true}
                          disabled={true}
                          // error={validation.country}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Project Address"
                          name="projectAddress"
                          value={
                            getPODetails?.projectAddress +
                              getPODetails?.projectAddress2 || ""
                          }
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <p className="fw-medium">PO Attachments</p>
                        {getPODetails?.purchaseOrderFileAttachment && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(
                                getPODetails?.purchaseOrderFileAttachment,
                              )
                            }
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* table */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Product Details</span>
                      <span className="subHeaderTitle">Product Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={productDetailsCol}
                          data={productDetailsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <Col xs={12} md={2} lg={2} className="">
              <button
                className="btnTable"
                onClick={handleSave}
                // disabled={disabled}
              >
                <i className="bi bi-save"></i> Create
              </button>
            </Col>
          </div>
        </Col>
      </Row>

      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default CreateWO;
